/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Links_HintInputs */

const cs_links_hint = /** @type {(inputs: Links_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube, Matterport, virtuální prohlídky.`)
};

const en_links_hint = /** @type {(inputs: Links_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YouTube, Matterport, virtual tours.`)
};

/**
* | output |
* | --- |
* | "YouTube, Matterport, virtual tours." |
*
* @param {Links_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const links_hint = /** @type {((inputs?: Links_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Links_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_links_hint(inputs)
	return cs_links_hint(inputs)
});